import React from "react"

const Banner = () => {
    return(
        <div className="container">
        <header style={{marginTop: '70px'}}>
         <div className="headerText">
         <div>
         <h1>Wonderful shoping website</h1>
            <p>Enjoy shopping with Go Shop</p>
         </div>
         </div>
        </header>
        </div>
    )
}

export default Banner;